import React, {Component} from 'react';

import Layout from '../../components/Layout'
import NewPost from '../../pages/NewPost'
import Loading from '../../components/Base/Loading'

/* Container for New Posts page */

class NewPostContainer extends Component {

	state = {
		faculty: [],
		loading: false
	};

	componentDidMount() {
		this.setState({loading: true});
		this.fetchFacultyList()
	}

	fetchFacultyList = async () => {
		try {
			let faculty = [];
			let facultyRef = await this.props.firebase.faculties().get();
			console.log(facultyRef);
			facultyRef.docs.forEach(doc => faculty.push({id: doc.id, ...doc.data()}));
			this.setState({faculty, loading: false})
		} catch (error) {
			console.log(error)
		}
	};

	render() {
		const {school} = this.props;

		return (
			<Layout {...this.props} noSideBar noFooter>
				{school === null ? <Loading/> :
					<NewPost {...this.props} {...this.state}/>}
			</Layout>
		);
	}
}


export default NewPostContainer;
